module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": false
    },
    on: {
      "close": _vm.clearSelectedPerson
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Agent details")]), _vm._v(" "), (_vm.getSelectedPerson) ? _c('h3', [_vm._v(_vm._s(_vm.getSelectedPerson.brandName))]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": "DETAILS"
    }
  }, [_c('agent-edit', {
    attrs: {
      "showButtons": false,
      "agent": _vm.tempSelectedPerson
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "COMMISSIONS"
    }
  }, [_c('commissions', {
    attrs: {
      "showButtons": false,
      "passedForm": _vm.tempSelectedPerson
    }
  })], 1), _vm._v(" "), (_vm.showOtaAdvancedSettingsTab) ? _c('tab', {
    attrs: {
      "name": "ADVANCED SETTINGS"
    }
  }, [_c('ota-settings', {
    attrs: {
      "agent": _vm.tempSelectedPerson,
      "otaChannelType": _vm.tempSelectedPerson.channelType
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center mb-4 p-3"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn green wider",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-040654d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-040654d4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/AgentView.vue
// module id = 895
// module chunks = 0